
export const MILLISECONDS_IN_A_SECOND = 1000;
export const SECONDS_IN_A_MINUTE = 60;

export const TWO_MINUTES_MILLISECONDS = 2 * SECONDS_IN_A_MINUTE * MILLISECONDS_IN_A_SECOND;